import { type NotificationTypeConfig } from "@indigo-components";

export const NOTIFICATION_BAR_MIN_SIZE = 15; // percent (~270px on 1800px viewport)
export const NOTIFICATION_BAR_MAX_SIZE = 25; // percent

export const NOTIFICATION_TYPE_CONFIG: Record<string, NotificationTypeConfig> =
  {
    APPOINTMENT_READY_TO_REVIEW: {
      icon: "clipboard-list",
      bgColor: "var(--indigo-sky-50)",
      iconColor: "var(--indigo-sky-600)",
      label: "Ready to review",
    },
    REPORT_READY_FOR_PHYSICIAN_REVIEW: {
      icon: "report",
      bgColor: "var(--indigo-olive-50)",
      iconColor: "var(--indigo-olive-600)",
      label: "Physician review",
    },
    UPCOMING_REPORTS_TO_GENERATE: {
      icon: "all-appointments-tab-icon",
      bgColor: "var(--indigo-amber-50)",
      iconColor: "var(--indigo-amber-600)",
      label: "Upcoming reports",
    },
    REPORT_READY_FOR_SUBMISSION: {
      icon: "report",
      bgColor: "var(--indigo-rose-50)",
      iconColor: "var(--indigo-rose-600)",
      label: "Ready for submission",
    },
    LATE_RECORDS_AFTER_HISTORY: {
      icon: "upload-file",
      bgColor: "var(--indigo-sky-50)",
      iconColor: "var(--indigo-sky-600)",
      label: "New records",
    },
  };
